Wee.fn.make('header', {
	$header: $('ref:stickyHeader'),
	previousScroll: false,
	previousScrollDown: false,
	scrollDownFrom: 0,
	navInitialTop: false,
	paused: false,
	init: function() {
		var scope = this;

		$($._win).on('scroll', function() {
			if (! this.paused) {
				scope.checkScroll();
			}
		});
	},
	checkScroll: function() {
		var scope = this,
			scrollPos = $.scrollTop(),
			$header = this.$header,
			scrollingUp = scope.previousScroll > scrollPos;

		if (! scrollingUp && ! scope.previousScrollDown) {
			scope.previousScrollDown = true;

			scope.scrollDownFrom = scrollPos;
		}

		if (scope.previousScroll === false) {
			scope.previousScroll = scrollPos;
			scope.navInitialTop = $header.position().top;
		} else {
			if (scrollPos <= scope.navInitialTop) {
				scope.convertHeaderToFull();
			} else if (scrollingUp) {
				scope.previousScrollDown = false;
				scope.convertHeaderToSticky();
			} else if ($header.hasClass('-is-sticking') && scrollPos - scope.scrollDownFrom > 15) {
				scope.hideHeader();
			}
		}

		scope.previousScroll = scrollPos;
	},
	hideHeader: function() {
		var $header = this.$header;

		if ($header.hasClass('-is-sticking')) {
			$header.removeClass('-is-sticking');
		}
	},
	convertHeaderToSticky: function() {
		var $header = this.$header,
			$wrapper = $('ref:navWrap');

		if (! $header.hasClass('-is-sticking')) {
			$header.css('top', '-' + $header.height() + 'px');

			setTimeout(function() {
				$header.addClass('-is-sticking')
					.addClass('-is-stuck');

				$wrapper.addClass('-is-shifted');
			}, 1);
		}
	},
	convertHeaderToFull: function(force) {
		var $header = this.$header,
			$wrapper = $('ref:navWrap');

		if (force || ($header.hasClass('-is-sticking'))) {
			$header.css('top', 'auto')
				.removeClass('-is-sticking')
				.removeClass('-is-stuck');

			$wrapper.removeClass('-is-shifted');
		}
	},
	pauseHeader: function() {
		this.paused = true;
	},
	resumeHeader: function() {
		this.paused = false;
	},
	isStuck: function() {
		return this.$header.hasClass('-is-stuck');
	},
	height: function() {
		return this.$header.height(true);
	}
});